/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

export const cancelSelectValue = (selectRef, value) => {
  if (selectRef.current) { selectRef.current.select.setValue(value || ''); }
};

export const clearSelectValue = (selectRef) => {
  if (selectRef.current) { selectRef.current.select.setValue(''); }
};

const EpFormSelect = forwardRef(({
  labelText, optionsSelect, onChange, inputId, value, isSearchable,
  placeholderText, classError, onBlur, inputName, customRef,
}) => {
  const customStyles = {
    menuPortal: provided => ({ ...provided, zIndex: 9999 }),
    menu: provided => ({ ...provided, zIndex: 9999 }),
  };

  return (
    <>
      <label htmlFor={inputId} className="form-label">{labelText}</label>
      <Select
        ref={customRef}
        id={inputId}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={customStyles}
        className={` ${classError || ''}`}
        placeholder={placeholderText}
        isSearchable={!!isSearchable}
        value={optionsSelect ? optionsSelect.find(option => option.value === value) : ''}
        onBlur={val => onBlur(val)}
        onChange={val => onChange(val)}
        options={optionsSelect}
        maxMenuHeight={180}
        name={inputName}
        menuPlacement="auto"
        menuShouldBlockScroll
      />
    </>
  );
});

export default EpFormSelect;

EpFormSelect.defaultProps = {
  placeholderText: '',
  value: null,
  isSearchable: true,
  customRef: null,
};

EpFormSelect.propTypes = {
  placeholderText: PropTypes.string,
  optionsSelect: PropTypes.arrayOf(PropTypes.object).isRequired,
  labelText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputName: PropTypes.string.isRequired,
  value: PropTypes.any,
  inputId: PropTypes.string.isRequired,
  isSearchable: PropTypes.bool,
  classError: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  customRef: PropTypes.object,
};
